import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, as = "div", className = "", ...rest }) => {
  const C = motion[as];
  return (
    <C
      className={className}
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.85, ease: [0.22, 1, 0.36, 1], delay }}
      {...rest}
    >
      {children}
    </C>
  );
};

export const LogoMark = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true" focusable="false">
    <rect width="48" height="48" rx="14" fill="var(--brand)" />
    <path d="M9 36h10v-8h9v-8h11" fill="none" stroke="var(--brand-fg)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="33" cy="12" r="4.5" fill="var(--sun)" />
  </svg>
);
